// extracted by mini-css-extract-plugin
module.exports = {"modal-tab":"ModuleBuilder_modal-tab__2HoGN","details-tab":"ModuleBuilder_details-tab__eXD_F"};